import { useIntl } from 'react-intl'
import { Table } from 'src/feature/bite/component/Table'
import { getDateAndTime } from 'src/feature/bite/helpers/date'
import { useStore } from 'src/feature/store/hook'

const StoreTerminals = ({ loading }: { loading: boolean }) => {
  const intl = useIntl()
  const { detail, detailSet, tabFilter, tabFilterSet } = useStore()

  const data = detail?.Terminal?.dataList || []
  const paging = detail?.Terminal?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'TerminalId',
      dataIndex: 'terminalId',
      title: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.TERMINAL_ID' }),
      tooltip: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.TERMINAL_ID_TOOLTIP' }),
    },
    {
      key: 'TerminalType',
      dataIndex: 'deviceModel',
      title: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.TERMINAL_TYPE' }),
    },
    {
      key: 'status',
      dataIndex: 'statusID',
      title: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.STATUS' }),
      // storeStatus: true,
      render: (text: any) => (
        <>
          <span className={`badge badge-light-${text === 1 ? 'success' : 'danger'} fw-bolder`}>
            {text === 1 ? 'Active' : 'Inactive'}
          </span>
        </>
      ),
    },
    {
      key: 'LoyaltyStatus',
      dataIndex: 'loyaltyStatusID',
      title: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.LOYALTY_STATUS' }),
      // status: true,
      render: (text: any) => (
        <>
          <span className={`badge badge-light-${text === 1 ? 'success' : 'danger'} fw-bolder`}>
            {text === 1 ? 'Active' : 'Inactive'}
          </span>
        </>
      ),
    },
    {
      key: 'LastTRXDate',
      dataIndex: 'lastTrxDate',
      title: intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS.LAST_TRX_DATE' }),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'detail',
      dataIndex: 'detail',
      title: intl.formatMessage({ id: 'STORE.LIST.ACTION' }),
      render: (text: string, record: any) => {
        return (
          <a href={`/terminals/${record.terminalId}`}>
            {intl.formatMessage({ id: 'STORE.LIST.DETAIL' })}
          </a>
        )
      },
    },
  ]

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS' })}
            </h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({ id: 'STORE.DETAIL.TERMINALS_TOOLTIP' })}
            </p>
          </div>
        </div>
        {/* <div className='card-title m-0'>
          <a type='button' className='btn btn-light' href='/terminals/new-terminal'>
            <i className='bi bi-plus-circle-fill fs-2'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {intl.formatMessage({id: 'TERMINAL.DETAIL.CREATE'})}
          </a>
        </div> */}
      </div>

      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <Table
            loading={loading}
            dataSource={data}
            columns={Columns}
            pagination={{
              current: paging.currentPageNumber,
              pageSize: paging.pageSize,
              total: paging.totalCount,
              onChange: (page: any) => {
                if (!detail || !detail.Terminal) return
                const { pageSize, current } = page
                const currentPage = pageSize !== detail.Terminal.paging.pageSize ? 1 : current

                detailSet({
                  ...detail,
                  Terminal: {
                    ...detail.Terminal,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  },
                })

                tabFilterSet({
                  ...tabFilter,
                  paging: {
                    currentPageNumber: currentPage,
                    pageSize: pageSize,
                  },
                })
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default StoreTerminals
